import * as yup from 'yup';
import { GrantType } from '../types';

export const defaultSettingsByGrantType: Partial<Record<GrantType, object>> = {
  [GrantType.AuthorizationCode]: {
    tokenUri: '',
    clientId: '',
    clientSecret: '',
    authUri: '',
    scope: '',
  },
  [GrantType.ClientCredentials]: {
    tokenUri: '',
    clientId: '',
    clientSecret: '',
    scope: '',
    audience: '',
  },
  [GrantType.EmailCredentials]: {
    tokenUri: '',
    email: '',
    password: '',
  },
  [GrantType.JwtCertificate]: {
    payloadAlgorithm: 'RS256',
    claims: {},
  },
};

export const GRANT_TYPE_OPTIONS: GrantType[] = [
  GrantType.AuthorizationCode,
  GrantType.ClientCredentials,
  GrantType.EmailCredentials,
  GrantType.JwtCertificate,
];

const baseSettingsShape = {
  tokenUri: yup.string().required(),
};

export const settingsShapeByGrantType: Partial<Record<GrantType, object>> = {
  [GrantType.AuthorizationCode]: {
    ...baseSettingsShape,
    clientId: yup.string().required(),
    clientSecret: yup.string().required(),
    authUri: yup.string().required(),
    scope: yup.string(),
  },
  [GrantType.ClientCredentials]: {
    ...baseSettingsShape,
    clientId: yup.string().required(),
    clientSecret: yup.string().required(),
  },
  [GrantType.EmailCredentials]: {
    ...baseSettingsShape,
    email: yup.string().required(),
    password: yup.string().required(),
  },
  [GrantType.JwtCertificate]: {
    payloadAlgorithm: yup.string().required(),
  },
};
